import React from 'react';
import PropTypes from 'prop-types';

import {eapiClient} from '../../../restClient';
import SimpleDropdown from '../SimpleDropdown';

import './comboBox.css';

export default class ComboBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownValue: '',
      inputValue: '',
      comboOptions: []
    };
  }

  componentDidMount() {
    if(this.props.resourcesUrl !== undefined) {
      eapiClient(this.props.resourcesUrl)
      .then(({data, status}) => {
        this.setState({comboOptions: data.responseData.classificationNodes});
      });
    }else {
      this.setState({comboOptions: this.props.comboOptions});
    }

    if(this.props._dropdownValue !== undefined) {
      this.setState({dropdownValue: this.props._dropdownValue.value});
    }

    if(this.props._value !== undefined) {
      this.setState({inputValue: this.props._value});
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.resourcesUrl === undefined && nextProps.comboOptions !== this.props.comboOptions) {
      this.setState({comboOptions: this.props.comboOptions});
    }
  }

  handleInputChange = (e) => {
    // this.validateInput(e);
    this.props.setComboBoxvalue(e.target.value, e.target.name);
    this.setState({inputValue: e.target.value});
  }

  handleDropdownChange = (e) => {
    const dropdownSelection = {
      name: e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text,
      value: e.target.value
    }
    this.props.setComboBoxvalue(dropdownSelection, e.target.name);
    this.setState({dropdownValue: e.target.value});
  }

  render()  {
    return (
    <div className="dropdown-combo-wrapper">
      <div className="combo-dropdown">
        <SimpleDropdown name={this.props.comboDropdownName}
        value={this.state.dropdownValue}
        _onChange={this.handleDropdownChange}
        options={this.state.comboOptions || []}
        valueSelector={this.props.valueSelector}
        optionTextSelector={this.props.optionTextSelector}
        type={this.props.dropdownType}
        defaultValue ={this.props.defaultValue}/>
      </div>
      <div className="combo-dropdown">
        <input type="text"
               name={this.props.comboInputName}
               value={this.state.inputValue}
               minLength={this.props.min}
               maxLength={this.props.max}
               onChange={this.handleInputChange} />
      </div>
      <div className="gdocs-clear-float"></div>
    </div>
    )
  }
}

ComboBox.defaultProps = {
  valueSelector: "id",
  optionTextSelector: "description",
  dropdownType: "number"
}

ComboBox.propTypes = {
  resourcesUrl: PropTypes.string,
  comboOptions: PropTypes.arrayOf(PropTypes.object),
  comboDropdownName: PropTypes.string.isRequired,
  comboInputName: PropTypes.string.isRequired,
  setComboBoxvalue: PropTypes.func.isRequired,
  _value: PropTypes.string,
  _dropdownValue: PropTypes.string,
  valueSelector: PropTypes.string,
  optionTextSelector: PropTypes.string,
  dropdownType: PropTypes.string,
  setFieldValidtionState: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/common/ComboBox/comboBox.js